(function($, Drupal, window, document) {
  'use strict';
  Drupal.behaviors.recordIssueJS = {
    attach: function recordIssueJS(context, settings) {
      if (typeof context['location'] !== 'undefined') { // Only fire on document load.
      var position;
      var navigation = function () {
        var labelChange = '<label for ="edit-search"> By Category: </label>';
        $('.menu-item--last a:first').replaceWith(labelChange);
        $(" .menu--record-navigation-links a[href^='#']").on('click', function(e) {

          if ($(window).width() > 768 ) {
            position = $($(this).attr("href")).offset().top - $('#primaryNavigation').height();
          }else {
            position = $($(this).attr("href")).offset().top - $('#primaryNavigationMobile').height();
          }
          $("body, html").animate({
          scrollTop: position
          },600);
          });
      }

      $(window).on('load', navigation);



      }
    }
  };

})(jQuery, Drupal, window, document);
